import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisVertical,
  faPause,
} from "@fortawesome/pro-regular-svg-icons";

export type EllipsesMenuCoutasProps = {
  functionButtonPause?: () => void;
  functionButtonModifyPause?: () => void;
  functionButtonLink?: () => void;
  activation?: number;
  canPauseFee?: boolean;
};

const EllipsesMenuCoutas: React.FC<EllipsesMenuCoutasProps> = ({
  functionButtonPause,
  functionButtonModifyPause,
  functionButtonLink,
  canPauseFee,
  activation,
}) => {
  return (
    <Menu as="div" className="relative flex-none">
      <MenuButton className="mt-1 block p-2 text-primary hover:text-primary-900">
        <span className="sr-only">Open options</span>
        <FontAwesomeIcon
          icon={faEllipsisVertical}
          aria-hidden="true"
          className="h-5 w-5"
        />
      </MenuButton>
      <MenuItems className="absolute right-0 z-50 mt-2 w-auto origin-top-right rounded-md bg-white shadow-lg ring-1 ring-gray-900/5 transition focus:outline-none">
        {canPauseFee && (
          <MenuItem>
            <a
              onClick={functionButtonPause}
              href="#"
              className="block px-3 py-1 text-sm leading-6 text-primary hover:text-primary-900"
            >
              <FontAwesomeIcon icon={faPause} className="mr-2" />
            </a>
          </MenuItem>
        )}

        {activation !== 1 && (
          <MenuItem>
            <a
              onClick={functionButtonModifyPause}
              href="#"
              className="block px-3 py-1 text-sm leading-6 text-primary hover:text-primary-900"
            >
              Modificar pausa
            </a>
          </MenuItem>
        )}

        <MenuItem>
          <a
            onClick={functionButtonLink}
            href="#"
            className="block px-3 py-1 text-sm leading-6 text-primary hover:text-primary-900"
          >
            Link
          </a>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
};

export default EllipsesMenuCoutas;
